<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="品牌管理">
      <!-- 超管、开发者才可以新增 -->
      <template  v-if="roleId == 1">
        <el-button size="small" type="primary" @click="newlyAdded"
          >新增</el-button
        >
      </template>
    </pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <template  v-if="roleId == 1">
            <div class="button button_modify" @click="editButton(row.row)">
              <i class="iconfont icon-bianji"></i> 编辑
            </div>
          <!-- 超管、开发者才可以增、减 -->

            <div class="button button_revoke" @click="deleteRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 删除
            </div>
          </template>

          <!-- <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="160"
            trigger="click"
          >
            <ul class="moreOperations">
              <li @click="activation(row.row)">
                <i class="iconfont icon-jihuo"></i> 激活
              </li>
              <li @click="deleteRows(row.row)">
                <i class="iconfont icon-shanchu"></i> 删除
              </li>
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover> -->
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

<script>
import {
  getbrandorigin,
  brandorigindel,
} from "@/api/basicConfiguration";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
  is_showAll: 1,
};
export default {
  name: "brandManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      roleId: 0,
      compId: 0,
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "品牌/产地",
            type: "input",
            key: "keywords",
          },

        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            sortable: true,
            width: 100,
          },
          {
            label: "品牌",
            prop: "brandname",
            width: 260,
          },
          {
            label: "产地",
            prop: "origin",
            width: 150,
          },
          {
            label: "排序",
            prop: "sort_by",
            width: 150,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    // 门店管理中：商户只能编辑基础信息
    this.roleId = this.$store.getters.userRole;
    // if (this.roleId != 1) {
    //   this.basicListconfig.search.shift();
    // }
    this.compId = this.$store.getters.userInfo.compId;

    // 初始化列表内容
    this.getlist();
    this.obtainDataSource();
  },
  methods: {
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认锁定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        shopLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认激活?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        shopactive({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        brandorigindel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;

      // 平台超管看所有，其他人只能看自己商户店铺
      // if (this.roleId != 1) {
      //   this.basicListconfig.searchParameters.compId = this.compId;
      // }
      // this.basicListconfig.searchParameters.is_showAll = 1;
      getbrandorigin(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    obtainDataSource() {

    },

  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/brandManagement/index.vue